module.exports = __webpack_public_path__ + "img/copiar.cea12286.svg";